// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"486":"1f79119e","553":"5a7f638c","776":"b133a6b2"}[chunkId] + ".js";
};